import { sealedWaxBoxTypeOptions } from "../layouts/livesearchpane/options.js";
import { SAVED_SEARCH_TYPES } from "../../globals";

export const generateQueryString = (terms, type) => {
  Object.values(terms).forEach((val) => {
    if (typeof val === "string") {
      val = encodeURIComponent(val);
    }
  });

  const {
    queryYear,
    queryPlayerName,
    querySet,
    querySport,
    queryVariation,
    querySetVariation,
    queryCardNumber,
    querySealedType,
    queryOtherTerms,
    queryExcludeTerms,
    queryGrade,
    queryExcludeLots,
    queryExcludeSealed,
    queryOtherTermsNewItem,
    queryExcludeTermsNewItem,
    // Popular Card Charts
    cid,
    players,
    sets,
    variations,
    setVariations,
    years,
    grades,
    startDate,
    endDate,
    rcOnly,
    // Popular Wax Charts
    swid,
    // Sets
    sports,
    setNameYears,
    boxTypes,
    // Intl. Reports - Grade Ratios
    grade1,
    grade2,
    // Intl. Reports - Player Ratios
    player1,
    player2,
    // Intl. Reports - Variation Ratios
    variation1,
    variation2,
  } = terms;

  const hasMinimumValidFields = (type) => {
    switch (type) {
      case SAVED_SEARCH_TYPES.SALES_LOOKUP:
        return (
          queryYear ||
          querySet ||
          queryVariation ||
          queryCardNumber ||
          queryOtherTerms.length ||
          queryExcludeTerms.length
        );
      default:
        return true;
    }
  };

  // This prevents against saving a search with just the exclude lots or exclude sealed checkboxes checked
  let hasMinimumFields = hasMinimumValidFields(type);

  let search = [];
  if (cid) search.push(`cid=${cid}`);
  if (swid) search.push(`swid=${swid}`);
  if (queryYear) search.push(`year=${encodeURIComponent(queryYear)}`);
  if (queryPlayerName) search.push(`player=${encodeURIComponent(queryPlayerName)}`);
  if (querySet) search.push(`set=${encodeURIComponent(querySet)}`);
  if (querySport) search.push(`sport=${encodeURIComponent(querySport)}`);
  if (queryVariation) search.push(`variation=${encodeURIComponent(queryVariation)}`);
  if (querySetVariation) search.push(`set_variation=${encodeURIComponent(querySetVariation)}`);
  if (queryCardNumber) search.push(`number=${encodeURIComponent(queryCardNumber)}`);
  if (queryOtherTerms) search.push(`other_terms=${encodeURIComponent(queryOtherTerms.join(","))}`);
  if (queryExcludeTerms) search.push(`exclude_terms=${encodeURIComponent(queryExcludeTerms.join(","))}`);
  if (queryGrade) search.push(`grade=${encodeURIComponent(queryGrade)}`);
  // We don't want to save a query that's just exclude_lots=trencodeURIComponent(ue - that's pretty use)less
  if (queryExcludeLots && hasMinimumFields) search.push(`exclude_lots=${encodeURIComponent(queryExcludeLots)}`);
  if (queryExcludeSealed && hasMinimumFields) search.push(`exclude_sealed=${encodeURIComponent(queryExcludeSealed)}`);
  if (queryOtherTermsNewItem) search.push(`other_terms_new_item=${encodeURIComponent(queryOtherTermsNewItem)}`);
  if (queryExcludeTermsNewItem) search.push(`exclude_terms_new_item=${encodeURIComponent(queryExcludeTermsNewItem)}`);
  // Popular Card Charts terms
  if (players) search.push(`players=${players.join(",")}`);
  if (sets) search.push(`sets=${sets.join(",")}`);
  if (variations) search.push(`variations=${variations.join(",")}`);
  if (setVariations) search.push(`set_variations=${setVariations.join(",")}`);
  if (years) search.push(`years=${years.join(",")}`);
  if (grades) search.push(`grades=${grades.join(",")}`);
  if (startDate) search.push(`start_date=${encodeURIComponent(startDate)}`);
  if (endDate) search.push(`end_date=${encodeURIComponent(endDate)}`);
  if (sports) search.push(`sports=${sports.join(",")}`);
  if (setNameYears) search.push(`set_name_years=${setNameYears.join(",")}`);
  if (boxTypes) search.push(`box_types=${boxTypes.join(",")}`);
  if (querySealedType) {
    const option = sealedWaxBoxTypeOptions.find(({ id }) => id === querySealedType);
    search.push(`sealed_type=${encodeURIComponent(option ? option.id : querySealedType)}`);
  }
  if (rcOnly) search.push("rc_only=true");

  // Intl. Reports - Grade Ratios
  if (grade1) search.push(`grade1=${encodeURIComponent(grade1)}`);
  if (grade2) search.push(`grade2=${encodeURIComponent(grade2)}`);

  // Intl. Reports - Variation Ratios
  if (variation1) search.push(`variation1=${encodeURIComponent(variation1)}`);
  if (variation2) search.push(`variation2=${encodeURIComponent(variation2)}`);

  // Intl. Reports - Player Ratios
  if (player1) search.push(`player1=${encodeURIComponent(player1)}`);
  if (player2) search.push(`player2=${encodeURIComponent(player2)}`);

  if (search.length) {
    search = `?${search.join("&")}`;
    return search;
  } else {
    return "";
  }
};
